// extracted by mini-css-extract-plugin
module.exports = {"group":"CaseList_style_group__2ujaX"};